// extracted by mini-css-extract-plugin
export default {"button":"button_button__sRkXk","buttonCaption":"button_buttonCaption__K7D2h","spinner":"button_spinner__ybZzX"};